import Opportunities from './Opportunities';

export * from './Opportunities';
export default Opportunities;
